var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Effect, Actions } from '@ngrx/effects';
import { AuthService } from '../../auth.service';
import * as authAction from '../actions/auth.actions';
import * as configAction from '../actions/config.action';
import { mergeMap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { Observable } from 'rxjs/Observable';
import { AccountType } from '../../users/account-type';
import { UserService } from '../../shared/user.service';
var AuthEffect = /** @class */ (function () {
    function AuthEffect(actions, auth, userService) {
        var _this = this;
        this.actions = actions;
        this.auth = auth;
        this.userService = userService;
        this.loginUser = this.actions.ofType(authAction.LOGIN_USER)
            .map(function (action) { return action.payload; })
            .pipe(mergeMap(function (user) {
            return _this.auth.signIn(user).map(function (_user) {
                if (_user.accountType === AccountType.POPUP) {
                    if (_user.popupStores.length === 0) {
                        _this.auth.signOut();
                        return new authAction.LoginUserFail('No Stores assigned to your account. Please contact store.');
                    }
                    return new authAction.LoginUserSuccess(_user);
                }
                else {
                    _this.auth.signOut();
                    return new authAction.LoginUserFail('Access denied');
                }
            }).catch(function (error) { return of(new authAction.LoginUserFail('Invalid Login Credentials')); });
        }));
        this.loggedInUserData = this.actions.ofType(authAction.LOAD_USER)
            .pipe(mergeMap(function () {
            return _this.userService.getUserData(_this.auth.currentUser.getValue().id)
                .map(function (r) { return new authAction.LoadUserSuccess(r); })
                .catch(function (e) { return of(new authAction.LogoutUser()); });
        }));
        this.logoutUser = this.actions.ofType(authAction.LOGOUT_USER)
            .map(function () {
            _this.auth.signOut();
            return new authAction.LogoutUser();
        });
        this.loadAppConfig = this.actions.ofType(configAction.GET_CONFIG)
            .pipe(mergeMap(function () {
            return _this.auth.appConfig()
                .map(function (r) { return new configAction.GetConfigSuccess(r); })
                .catch(function (e) { return of(new configAction.GetConfigFail(e)); });
        }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], AuthEffect.prototype, "loginUser", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], AuthEffect.prototype, "loggedInUserData", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Observable)
    ], AuthEffect.prototype, "logoutUser", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], AuthEffect.prototype, "loadAppConfig", void 0);
    return AuthEffect;
}());
export { AuthEffect };



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/store/effects/auth.effect.ts.pre-build-optimizer.js